import { render, staticRenderFns } from "./FacilityManagementDetail.vue?vue&type=template&id=3b1e5069&scoped=true"
import script from "./FacilityManagementDetail.vue?vue&type=script&lang=ts"
export * from "./FacilityManagementDetail.vue?vue&type=script&lang=ts"
import style0 from "./FacilityManagementDetail.vue?vue&type=style&index=0&id=3b1e5069&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e5069",
  null
  
)

export default component.exports